<template>
    <v-menu transition="slide-x-transition"
            top
            v-bind="$attrs" v-on="$listeners">
        <template v-slot:activator="{on}">
            <v-btn :color="color" v-on="on">
                <slot/>
            </v-btn>
        </template>
        <template>
            <v-card class="overflow-hidden">
                <slot name="title" v-bind="{title}">
                    <p class="text-h6 ma-1">
                        {{ title }}
                    </p>
                </slot>
                <v-container class="pa-0">
                    <v-row no-gutters>
                        <v-col :order="confirmFirst? 1:0">
                            <slot name="cancel" v-bind="{cancelText, on:{click:() => $emit('cancel')}}">
                                <v-btn color="primary"
                                       :width="width"
                                       text block
                                       @click="$emit('cancel')">
                                    {{ cancelText }}
                                </v-btn>
                            </slot>
                        </v-col>
                        <v-col cols="auto">
                            <slot name="confirm" v-bind="{confirmText, on:{click:() => $emit('confirm')}}">
                                <v-btn :color="color"
                                       dark
                                       @click="$emit('confirm')">
                                    {{ confirmText }}
                                </v-btn>
                            </slot>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </template>
    </v-menu>
</template>

<script>
export default {
    name: "ConfirmButton",
    props: {
        width: {},
        title: {
            type: String,
            default: "Sicher?"
        },
        confirmText: {
            type: String,
            default: "Confirm"
        },
        cancelText: {
            type: String,
            default: "Cancel"
        },
        color: {
            type: String,
            default: "primary"
        },
        confirmFirst: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'confirm',
        'cancel'
    ]
}
</script>

<style scoped>

</style>
